import React, { useState } from "react";
import styled from "styled-components";

import { featuresManager } from "../../../../../shared/core/service/services";
import { type Mandate, MandateStatus } from "../../../../../shared/domains/mandates/mandate";
import { useObservable } from "../../../../../shared/utils/observable";
import CardMoreMenu from "../../../common/card-more-menu";
import { theme } from "../../../styles/theme";
import { MandateStatusPill } from "./mandate-status-pill";

type MandatesItemProps = {
  mandate: Mandate;
  handleMandateOppose: (mandate: Mandate) => void;
  handleMandateActivate: (mandate: Mandate) => void;
  handleMandateDetail: (mandate: Mandate) => void;
};

export const MandateItem = ({
  mandate,
  handleMandateOppose,
  handleMandateActivate,
  handleMandateDetail,
}: MandatesItemProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const features = useObservable(featuresManager.features);

  const handleToggleMenu = () => setIsMenuOpen((bool) => !bool);

  const handleCancel = () => {
    handleMandateOppose(mandate);
    handleToggleMenu();
  };

  const handlePlay = () => {
    handleMandateActivate(mandate);
    handleToggleMenu();
  };

  const hasScopeAndStatus =
    features.mandateManagement && (mandate.status === MandateStatus.ACTIVE || mandate.status === MandateStatus.OPPOSED);

  return (
    <StyledMandates onClick={() => handleMandateDetail(mandate)}>
      <div>
        <BoldText>{mandate.creditorName}</BoldText>
        <FrequencyText>{mandate.reference}</FrequencyText>
      </div>
      <StatusWrapper>
        <MandateStatusPill status={mandate.status} />
      </StatusWrapper>
      {hasScopeAndStatus && (
        <CardMoreMenu
          isRTL={false}
          isOpen={isMenuOpen}
          onToggle={handleToggleMenu}
          onCancel={handleCancel}
          onPlay={handlePlay}
          enableCancel={mandate.status === MandateStatus.ACTIVE}
          enablePlay={mandate.status === MandateStatus.OPPOSED}
        />
      )}
    </StyledMandates>
  );
};

const BoldText = styled.span`
  ${theme.bodyBlackBold}
  font-size: 16px;
`;

const FrequencyText = styled.div`
  ${theme.bodySmallGreyRegular}
`;

const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const StyledMandates = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 100px 20px 30px;
  border-radius: 13px;
  background-color: #ffffff;
  align-self: stretch;
  margin-top: 15px;
  cursor: pointer;
  transition: box-shadow 0.3s;
  &:hover {
    box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.05);
  }
`;
